<template lang="html">
  <div class="project-wall">
    <template v-if="projects.length">
      <ProjectWallTile
        v-for="item in projects"
        :key="item.id"
        :project="item"
      />
    </template>
    <Arc
      :random-range-rotation="{ min: 10, max: 220 }"
      :random-range-position-x="[
        { min: -5, max: 0 },
        { min: 86, max: 95 }
      ]"
      :random-range-position-y="{ min: 70, max: 80 }"
    />
  </div>
</template>

<script>
import ProjectWallTile from 'beisheim/components/elements/project-wall-tile'
import Arc from 'beisheim/components/elements/arc'

export default {
  components: {
    ProjectWallTile,
    Arc
  },
  props: {
    projects: {
      type: Array,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/fluid-type';
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/grid';
  @import 'beisheim/scss/breakpoints';

  .project-wall {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: scale(1) auto;
    min-width: $min-width;
    max-width: $max-width;
    @include grid-spacing(margin-bottom, 2);

    @include from(4) {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }
</style>
